import { saveLabel } from "./persistence.js";
import { isFormat, selectedFormat } from "./format.js";
import { getLanguages } from "./util.js";

const descriptionDefaults = {
  "as-packaged-description-en": {
    "canada/adult/vertical/as_prepared": "As sold",
    "legacy_fda/adult/vertical/as_prepared": "Mix",
  },
  "as-prepared-description-en": {
    "fda/adult/vertical/as_prepared": "As Prepared",
    "legacy_fda/adult/vertical/as_prepared": "As Prepared",
    "canada/adult/vertical/as_prepared": "Prepared",
  },

  "as-packaged-description-fr": { "canada/adult/vertical/as_prepared": "Tel que vendu" },
  "as-prepared-description-fr": { "canada/adult/vertical/as_prepared": "Préparé" },
};

export const initializeAPDescriptionControls = () => {
  const setupInput = (type) => {
    const inputElement = document.querySelector(`#${type}`);

    if (!inputElement) {
      return;
    }

    inputElement.addEventListener("change", (event) => {
      document
        .querySelectorAll(`[data-${type}]`)
        .forEach((el) => (el.textContent = event.target.value));

      syncAsPreparedServingVisibilityWithLabel();
      if (isFormat("fda/adult/vertical/as_prepared")) {
        document.dispatchEvent(new CustomEvent("label:dual-serving-line-changed"));
      }
      saveLabel({ [type.replaceAll("-", "_")]: event.target.value });
    });

    document.querySelector(`#${type}-reset`).addEventListener("click", () => {
      const defaultValue = descriptionDefaults[type][selectedFormat()];
      inputElement.value = defaultValue;
      inputElement.dispatchEvent(new Event("change"));
    });
  };

  setupInput("as-packaged-description-en");
  setupInput("as-packaged-description-fr");
  setupInput("as-prepared-description-en");
  setupInput("as-prepared-description-fr");
};

export const syncAsPreparedServingVisibilityWithLabel = () => {
  if (!isFormat("canada/adult/vertical/as_prepared")) {
    return;
  }
  const element = document.getElementById("CaDualFormatNFP-PreparedServingSize");
  if (!element) {
    return;
  }

  const languageFields = {
    en: "as-prepared-description-en",
    fr: "as-prepared-description-fr",
  };
  let shouldShow = true;

  // Check as prepared description values vs the defaults.
  // If they don't match hide the as prepared serving size
  getLanguages().forEach((language) => {
    const id = languageFields[language];
    if (
      descriptionDefaults[id][selectedFormat()].toLowerCase() !=
      document.getElementById(id).value.toLowerCase()
    ) {
      shouldShow = false;
    }
  });

  if (shouldShow) {
    element.classList.remove("is-hidden");
  } else {
    element.classList.add("is-hidden");
  }
};
